export default "__VITE_ASSET__CkT36MW4__"